module.exports = __webpack_public_path__ + "static/img/ysb.dde6b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ysb.jpg
// module id = gx+b
// module chunks = 73